import { Link, useSearchParams } from 'react-router-dom';
import Header from './partials/Header';
import { downloadLegalDocument, getLegalDocument } from '../legal/legalDocuments';
import '../css/Legal.css';

export default function LegalDocument({ kind }) {
    const [params] = useSearchParams();
    const requestedVersion = params.get('version');
    const document = getLegalDocument(kind, requestedVersion);

    return <div className="ef-page ef-policy-page">
        <Header />
        <main className="max-w-4xl mx-auto px-6 py-12 ef-legal-document">
            {!document ? <>
                <h1>Versione non disponibile</h1>
                <p>Il documento richiesto non è disponibile a questo indirizzo. Per una copia della versione accettata scrivi a <a href="mailto:info@easy-funeral.it">info@easy-funeral.it</a>.</p>
                <Link to={kind === 'terms' ? '/condizioni-agenzie' : '/privacy-policy'}>Consulta la versione attuale</Link>
            </> : <>
                <header className="mb-12">
                    <h1 className="text-4xl font-bold mb-4">{document.title}</h1>
                    <p>Versione {document.version} · Aggiornamento: {document.updatedAt}</p>
                    <div className="ef-legal-actions">
                        <button type="button" onClick={() => downloadLegalDocument(document, kind === 'terms' ? 'condizioni-agenzie' : 'privacy')}>Scarica il documento (.txt)</button>
                        <button type="button" onClick={() => window.print()}>Stampa</button>
                    </div>
                </header>
                <nav aria-label="Indice del documento" className="ef-legal-index">
                    {document.sections.map(section => <a key={section.id} href={`#${section.id}`}>{section.title}</a>)}
                </nav>
                {document.sections.map(section => <section id={section.id} key={section.id} className="mb-12 scroll-mt-24">
                    <h2 className="text-2xl font-semibold mb-4">{section.title}</h2>
                    <div className="space-y-4 text-gray-700 leading-relaxed">{section.paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}</div>
                </section>)}
                <p className="ef-legal-related"><Link to="/informazioni-legali">Informazioni legali</Link> · <Link to="/condizioni-agenzie">Condizioni agenzie</Link> · <Link to="/privacy-policy">Informativa privacy</Link> · <Link to="/cookie-policy">Cookie Policy</Link></p>
            </>}
        </main>
    </div>;
}
